export enum CHROMECAST_EXPANDED_CONTROLLER_TEST_IDS {
    CAST_TO_BUTTON = 'cast_to_button',
}
